var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "modal modal-fullscreen modal-filter-details fade",
      attrs: {
        id: "modal-tag-node-add-talent",
        role: "dialog",
        "aria-labelledby": "shortlist-modal-label",
        "aria-hidden": "true",
      },
    },
    [
      _c(
        "div",
        {
          staticClass: "modal-dialog",
          attrs: { "data-backdrop": "true", "data-keyboard": "true" },
        },
        [
          _c("div", { staticClass: "modal-content" }, [
            _c("div", { staticClass: "modal-header" }, [
              _c(
                "h4",
                {
                  staticClass: "modal-title",
                  attrs: { id: "shortlist-modal-label" },
                },
                [_vm.$userIsAdmin ? [_vm._v("Select Stars")] : _vm._e()],
                2
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "modal-body" }, [
              _c("div", [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.search,
                      expression: "search",
                    },
                  ],
                  attrs: { placeholder: "Search..." },
                  domProps: { value: _vm.search },
                  on: {
                    keypress: function ($event) {
                      if (
                        !$event.type.indexOf("key") &&
                        _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                      )
                        return null
                      return _vm.getTalent.apply(null, arguments)
                    },
                    input: function ($event) {
                      if ($event.target.composing) return
                      _vm.search = $event.target.value
                    },
                  },
                }),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "input-group-btn" },
                  [
                    _c(
                      "ladda-button",
                      {
                        ref: "search",
                        staticClass: "btn btn-dark",
                        attrs: { type: "submit", click: _vm.getTalent },
                      },
                      [_vm._v("\n              Search\n            ")]
                    ),
                  ],
                  1
                ),
              ]),
              _vm._v(" "),
              _c(
                "div",
                [
                  _vm._l(_vm.searchTalent, function (talent) {
                    return _c(
                      "div",
                      {
                        key: talent.id,
                        staticStyle: { padding: "5px" },
                        attrs: { id: "talent-list" },
                      },
                      [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.selectedTalent,
                              expression: "selectedTalent",
                            },
                          ],
                          attrs: {
                            id: "talent-checkbox-" + talent.id,
                            type: "checkbox",
                          },
                          domProps: {
                            value: talent.id,
                            checked: Array.isArray(_vm.selectedTalent)
                              ? _vm._i(_vm.selectedTalent, talent.id) > -1
                              : _vm.selectedTalent,
                          },
                          on: {
                            change: function ($event) {
                              var $$a = _vm.selectedTalent,
                                $$el = $event.target,
                                $$c = $$el.checked ? true : false
                              if (Array.isArray($$a)) {
                                var $$v = talent.id,
                                  $$i = _vm._i($$a, $$v)
                                if ($$el.checked) {
                                  $$i < 0 &&
                                    (_vm.selectedTalent = $$a.concat([$$v]))
                                } else {
                                  $$i > -1 &&
                                    (_vm.selectedTalent = $$a
                                      .slice(0, $$i)
                                      .concat($$a.slice($$i + 1)))
                                }
                              } else {
                                _vm.selectedTalent = $$c
                              }
                            },
                          },
                        }),
                        _vm._v(" "),
                        _c(
                          "label",
                          { attrs: { for: "talent-checkbox-" + talent.id } },
                          [_vm._v(_vm._s(talent.name))]
                        ),
                      ]
                    )
                  }),
                  _vm._v(" "),
                  _c(
                    "lazy-loading",
                    {
                      ref: "lazyLoading",
                      staticClass: "text-center m-b-md",
                      attrs: {
                        "scroll-target": "#modal-tag-node-add-talent",
                        loading: _vm.searching,
                        "reached-bottom": _vm.getNextTalent,
                      },
                    },
                    [
                      _c("div", {
                        staticClass: "pickstar-loading",
                        attrs: { slot: "loading" },
                        slot: "loading",
                      }),
                      _vm._v(" "),
                      _c("span", {
                        attrs: { slot: "finished" },
                        slot: "finished",
                      }),
                    ]
                  ),
                ],
                2
              ),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "modal-footer" },
              [
                _c(
                  "button",
                  {
                    staticClass: "btn btn-lg btn-danger pull-left",
                    attrs: { type: "button", "data-dismiss": "modal" },
                    on: { click: _vm.handleModalClose },
                  },
                  [_c("i", { staticClass: "fa fa-close" }), _vm._v(" Cancel")]
                ),
                _vm._v(" "),
                _c(
                  "ladda-button",
                  {
                    staticClass: "btn btn-lg btn-primary",
                    attrs: { type: "button", click: _vm.saveTalent },
                  },
                  [
                    _c("i", { staticClass: "fa fa-check" }),
                    _vm._v(" Add\n        "),
                  ]
                ),
              ],
              1
            ),
          ]),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }